export default __webpack_public_path__ + "static/media/Panthers.c4d58e85.png";